export const environment = {
  production: false,
  autoDetect: false,
  apiUrl: 'https://testapi.protyco.de/api'
};
